
import { defineComponent, PropType } from 'vue'
import { AxiosResponse } from 'axios'
import { iBusinessModel } from '../../BusinessModelCatalogue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import metawebSelectDialogDescriptor from '@/modules/managers/businessModelCatalogue/metaweb/metawebSelectDialog/MetawebSelectDialogDescriptor.json'

export default defineComponent({
    name: 'metaweb-select-dialog',
    components: { Checkbox, Column, DataTable, Dialog },
    props: { visible: { type: Boolean }, selectedBusinessModel: { type: Object as PropType<iBusinessModel> } },
    emits: ['close', 'metaSelected'],
    data() {
        return {
            metawebSelectDialogDescriptor,
            businessModel: null as iBusinessModel | null,
            datasourceStructure: null as any,
            rows: [] as { value: string }[],
            selected: {} as any,
            allPhysicalSelected: false,
            allBusinessSelected: false,
            filters: {
                global: [filterDefault]
            } as Object,
            filteredRows: [] as { value: string }[],
            loading: false
        }
    },
    watch: {
        async businessModel() {
            await this.loadData()
        },
        async visible(value: boolean) {
            if (value) {
                this.loading = true
                await this.loadDatasourceStructure()
                this.loadRows()
                this.loading = false
            }
        }
    },
    async created() {
        await this.loadData()
    },
    methods: {
        async loadData() {
            this.loading = true
            this.loadBusinessModel()
            await this.loadDatasourceStructure()
            this.loadRows()
            this.loading = false
        },
        loadBusinessModel() {
            this.businessModel = this.selectedBusinessModel as iBusinessModel
        },
        async loadDatasourceStructure() {
            if (this.businessModel?.dataSourceId) {
                let url = `2.0/datasources/structure/${this.businessModel.dataSourceId}?`
                const urlParams = {} as any
                if (this.businessModel.tablePrefixLike) urlParams.tablePrefixLike = this.businessModel.tablePrefixLike
                if (this.businessModel.tablePrefixNotLike) urlParams.tablePrefixNotLike = this.businessModel.tablePrefixNotLike
                await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + url, { params: urlParams }).then((response: AxiosResponse<any>) => (this.datasourceStructure = response.data))
            }
        },
        loadRows() {
            this.rows = []
            if (this.datasourceStructure) {
                Object.keys(this.datasourceStructure).forEach((key: string) => {
                    this.rows.push({ value: key })
                    this.selected[key] = { physical: false, business: false }
                })
            }
        },
        setChecked(row: { value: string }, typeChecked: string) {
            if (typeChecked === 'business' && this.selected[row.value].business) {
                this.selected[row.value].physical = true
            } else if (typeChecked === 'physical' && !this.selected[row.value].physical) {
                this.selected[row.value].business = false
            }
        },
        setAllChecked(typeChecked: string) {
            Object.keys(this.selected).forEach((key: string) => {
                if (this.checkIfTheSelectedIsInFilteredRows(key)) {
                    if (typeChecked === 'business') {
                        this.selected[key].business = this.allBusinessSelected
                        if (this.allBusinessSelected) {
                            this.selected[key].physical = true
                            this.allPhysicalSelected = true
                        }
                    } else {
                        this.selected[key].physical = this.allPhysicalSelected
                        if (!this.allPhysicalSelected) {
                            this.selected[key].business = false
                            this.allBusinessSelected = false
                        }
                    }
                }
            })
        },
        checkIfTheSelectedIsInFilteredRows(key: string) {
            const index = this.filteredRows.findIndex((el: { value: string }) => el.value === key)
            return index !== -1
        },
        closeDialog() {
            this.$emit('close')
            this.filters['global'].value = ''
            this.selected = {}
            this.allPhysicalSelected = false
            this.allBusinessSelected = false
        },
        async onContinue() {
            if (!this.checkIfPhysicalModelIsSelected()) {
                this.$store.commit('setError', {
                    title: this.$t('common.error.generic'),
                    msg: this.$t('metaweb.selectDialog.noPhysicalModelsSelectedError')
                })
                return
            }

            await this.sendCheckedMetaweb()
        },
        async sendCheckedMetaweb() {
            this.loading = true
            const physicalModels = [] as string[]
            const businessModels = [] as string[]

            this.prepareDataForPost(physicalModels, businessModels)

            await this.$http
                .post(process.env.VUE_APP_META_API_URL + `/1.0/metaWeb/create`, { datasourceId: '' + this.businessModel?.dataSourceId, physicalModels: physicalModels, businessModels: businessModels, modelName: this.businessModel?.name })
                .then((response: AxiosResponse<any>) => {
                    this.$emit('metaSelected', response.data)
                })
                .catch(() => {})

            this.loading = false
        },
        prepareDataForPost(physicalModels, businessModels) {
            Object.keys(this.selected).forEach((key: string) => {
                if (this.selected[key].physical) physicalModels.push(key)
                if (this.selected[key].business) businessModels.push(key)
            })
        },
        checkIfPhysicalModelIsSelected() {
            let isSelected = false
            const keys = Object.keys(this.selected)

            for (let i = 0; i < keys.length; i++) {
                if (this.selected[keys[i]].physical) {
                    isSelected = true
                    break
                }
            }

            return isSelected
        },
        onRowsFiltered(event: any) {
            this.filteredRows = event.filteredValue
            this.allPhysicalSelected = true
            this.allBusinessSelected = true

            if (this.filteredRows.length === 0) {
                this.allPhysicalSelected = false
                this.allBusinessSelected = false
            }

            for (let i = 0; i < this.filteredRows.length; i++) {
                if (!this.selected[this.filteredRows[i].value].physical) {
                    this.allPhysicalSelected = false
                }
                if (!this.selected[this.filteredRows[i].value].business) {
                    this.allBusinessSelected = false
                }
            }
        }
    }
})
